import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { ReactComponent as Arrow } from '../../../../assets/images/arrow-right.svg'

const GoBack = styled(NavLink)`
  width: 100%;
  margin-bottom: 1rem;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text1};
  display: flex;
  font-weight: bold;
  user-select: none;

  :hover {
    color: ${({ theme }) => theme.yetiBlue};

    svg {
      fill: ${({ theme }) => theme.yetiBlue};
    }
  }
`

const GoBackArrow = styled(Arrow)`
  fill: ${({ theme }) => theme.text1};
  transform: rotate(180deg);
  margin-right: 0.5rem;
`

export interface INFTGoBack {
  url: string
  text: string
}

export default function NFTGoBack({ url, text }: INFTGoBack) {
  return (
    <GoBack to={url}>
      <GoBackArrow />
      {text}
    </GoBack>
  )
}
